export class GetFirstName {
  public execute(name: string) {
    const firstName = name.split(' ').at(0)
    if (!firstName) return null

    return firstName
  }
}
